import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Button, Card, CardActionArea, CardContent,  Icon,
    Paper, Tooltip, Typography,
    IconButton,
    Tab,
    Tabs,
    tabsClasses,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    useTheme

} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { FranquiaService, IDetalheFranquia, ILstDrop, ILstDropAtivosProposta } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService, lstTiposAtivos } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { IDadosPropostaTroca, IDadosPropostas, IDadosSavePropostas, PropostaService } from "../../shered/services/api/propostas/PropostaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                 <Box sx={{ p: UtilidadeService.isMobile() ? 0 : 1 }}>
                    <Grid>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

function a11yProps(index: number) {

    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}

                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
                prefix="R$"
            />
        );
    },
);


export const DetalheDePropostas: React.FC = () => {
    const theme = useTheme();
    const user = CookieService.get("access_user");
    const { id = 'nova' } = useParams<"id">();
    const { formRef, save } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useAuthContext();
    //const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [showAtivosSwap, setShowAtivosSwap] = useState(false);
    const [lstFranquiaDrop, setLstFranquiaDrop] = useState<ILstDrop[]>([]);
    const [lstFranquia, setLstFranquia] = useState<IDetalheFranquia[]>([]);
    const [lstAtivos, setLstAtivos] = useState<ILstDropAtivosProposta[]>([]);
    const [lstAtivoSwap, setLstAtivoSwap] = useState<ILstDropAtivosProposta[]>([]);
    const [multaQuebrada, setMultaQuebrada] = useState(false);
    const [lstDadosPropostaEnvia, setLstDadosPropostaEnvia] = useState<IDadosPropostaTroca[]>([]);
    const [lstDadosPropostaCabecalho, setLstDadosPropostaCabecalho] = useState<IDadosPropostas[]>([]);
    const [lstPropostaEnvia, setLstPropostaEnvia] = useState<IDadosPropostas[]>([]);
    const [lstPropostaRecebe, setLstPropostaRecebe] = useState<IDadosPropostas[]>([]);
    const [lstDadosPropostaCabecalhoRecebe, setLstDadosPropostaCabecalhoRecebe] = useState<IDadosPropostas[]>([]);
    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [valueTab, setValueTabRodada] = useState(0);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [nomeLiga, setNomeLiga] = useState("");
    const [logoImage, setLogoImage] = useState("");
    const [observacao, setObservacao] = useState("");
    const [qtdFranquias, setQtdFranquias] = useState(0);
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [franquiaEnvia, setFranquiaEnvia] = useState(0);
    const [franquiaRecebe, setFranquiaRecebe] = useState(0);
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [codigoTipoAtivo, setCodigoTipoAtivo] = useState(0);
    const [codigoAtivo, setCodigoAtivo] = useState(0);
    const [codigoAtivoSwap, setCodigoAtivoSwap] = useState(0);
    const [codigoAtivoSwapProtegida, setCodigoAtivoSwapProtegida] = useState(0);
    const [inicioProtecao, setInicioProtecao] = useState(0);
    const [fimProtecao, setFimProtecao] = useState(0);
    const [imagemPicks] = useState<any>("../../../picks.png");
    const [imagemPicksProtegida, setImagemPicksProtegida] = useState<any>("../../../lock2.png");
    const [imagemSwap] = useState<any>("../../../swap5.png");
    const [imagemMulta] = useState<any>("../../../multas.png");
    const [semImagem] = useState<any>("../../../semimagemescudo.png");
    const [dadosObservacao, setDadosObservacao] = useState<string[]>([]);
    const [lstTiposAtivosProposta, setLstTiposAtivosProposta] = useState<any[]>([]);
    const [idEdicao, setIdEdicao] = useState(0);
    const [separarMultaTemporada, setSepararMultaTemporada] = useState(0);
    const [valorMultaEditada, setValorMultaEditada] = useState("");

    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });
    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    const carregarInformacoes = async (id: any) => {
        const resultCrypt = UtilidadeService.decrypt(id);
        if (resultCrypt === "" || resultCrypt === undefined) {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setIsLoading(false);

            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Dados inválidos! ",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;

        }
        let decrpt = resultCrypt !== undefined ? resultCrypt?.split("|") : [];
        setFranquiaEnvia(Number(decrpt[1]))
        setIdEdicao(Number(decrpt[0]));
        await PropostaService.getPorCodigo(Number(decrpt[0]))
            .then((result) => {
                let dadosProposta = result.dado;
                let lstItensPropostas = dadosProposta.dados_Proposta;
                dadosProposta.franquias.forEach(f => {

                    let obj = {
                        codigo: f.codigo_Proposta,
                        logo_Franquia_Envia: f.logo,
                        logo_Franquia_Recebe: f.logo,
                        codigo_Franquia_Envia: f.codigo,
                        codigo_Franquia_Recebe: f.codigo,
                        nome_Franquia_Envia: f.nome,
                        nome_General_Manager_Envia: f.nome_General_Manager,
                        nome_Franquia_Recebe: f.nome,
                        nome_General_Manager_Recebe: f.nome_General_Manager,
                        situacao: f.situacao,
                        //logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                        //codigo_Franquia_Recebe: franquiaRecebe,
                        //nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                        //nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                        dados_Propostas: lstItensPropostas
                    }
                    lstDadosPropostaCabecalho.push(obj);
                });

                // dadosProposta.franquias.forEach(f => {
                //     let obj = {
                //         codigo: f.codigo_Proposta,
                //         logo_Franquia_Recebe: f.logo,
                //         codigo_Franquia_Recebe: f.codigo,
                //         nome_Franquia_Recebe: f.nome,
                //         nome_General_Manager_Recebe: f.nome_General_Manager,
                //         situacao: f.situacao,
                //         //logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                //         //codigo_Franquia_Recebe: franquiaRecebe,
                //         //nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                //         //nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                //         dados_Propostas: lstItensPropostas
                //     }
                //     lstDadosPropostaCabecalhoRecebe.push(obj);
                //});
            })
            .catch((errors) => {
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.data.statusHTTP === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
                else {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados da proposta! Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
            });

    }

    useEffect(() => {
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        else {
            LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setNomeLiga(liga.nome);
                    setLogoImage(liga.caminho_Logo);
                    setQtdFranquias(liga.quantidade_Franquia);
                    setCodigoFranquia(liga.codigo_Franquia);
                    setCodigoTemporada(liga.codigo_Temporada);
                    setSepararMultaTemporada(liga.separar_Multa_Temporada);
                    if (liga.abertura_Mercado !== true) {
                        navigate(`/liga/propostas/completa`);
                        return;
                    }
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });

            setIsLoading(true);

            const fetchData = async () => {
                await FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        setLstFranquia(result.dado);
                        let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome, outros: f.caminho_Logo, descricao: f.nome_Usuario }));
                        setLstFranquiaDrop(lstFranquia);
                        setLstTiposAtivosProposta(lstTiposAtivos);
                    })
                    .catch((errors) => {
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        if (errors.response.data.statusHTTP === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        else {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                    });


                if (id !== "nova") {
                    await carregarInformacoes(id);
                    setRemoveLoading(true);
                }
                else {
                    setRemoveLoading(true);
                }
                setIsLoading(false);
            }
            fetchData();
        }
    }, [codigoLiga, id]);

    const handleSave = async (dados: IDadosSavePropostas) => {

        setLstDadosPropostaEnvia([]);
        setRemoveLoading(false);
        setIsLoading(true);
        setShowModalMensagem(false);
        setObservacao(JSON.stringify(dadosObservacao));
        let lst: IDadosPropostaTroca[] = [];
        lstDadosPropostaCabecalho.forEach(f => (
            f.dados_Propostas.map(m => {
                if (lst.length === 0) {
                    lst.push(m);
                }
                if ((m.tipo_Ativo === 1 || m.tipo_Ativo === 2) && lst.find(x => x.codigo_Jogador === m.codigo_Jogador) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 3 && lst.find(x => x.codigo_Multa === m.codigo_Multa) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 4 && lst.find(x => x.codigo_Pick_Franquia === m.codigo_Pick_Franquia) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 5 && lst.find(x => x.codigo_Pick_Franquia === m.codigo_Pick_Franquia) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 6 && lst.find(x => x.codigo_Pick_Franquia === m.codigo_Pick_Franquia) === undefined) {
                    lst.push(m);
                }
            })));

        setLstDadosPropostaEnvia(lst);

        var propostaEnvolvida = lst.find(f => f.codigo_Franquia_Envia === codigoFranquia || f.codigo_Franquia_Recebe === codigoFranquia);
        if (propostaEnvolvida === undefined) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Não é possível registrar a Proposta! A sua franquia não está envolvida!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        const lstPropostasAux: any = lst.length > 0 ? lst.map(p => ({
            codigo_Franquia_Envia: p.codigo_Franquia_Envia,
            codigo_Franquia_Recebe: p.codigo_Franquia_Recebe,
            codigo_Jogador: p.codigo_Jogador !== undefined && p.codigo_Jogador > 0 ? p.codigo_Jogador : null,
            codigo_Jogador_Dispensa: p.codigo_Jogador_Dispensa !== undefined && p.codigo_Jogador_Dispensa > 0 ? p.codigo_Jogador_Dispensa : null,
            codigo_Pick_Franquia: p.codigo_Pick_Franquia !== undefined && p.codigo_Pick_Franquia > 0 ? p.codigo_Pick_Franquia : null,
            codigo_Multa: p.codigo_Multa !== undefined && p.codigo_Multa > 0 ? p.codigo_Multa : null,
            tipo_Ativo: p.tipo_Ativo,
            valor_Multa_Quebrada: separarMultaTemporada === 3 ? p.valor_Multa !== undefined ? parseFloat(p.valor_Multa?.replace("R$", "").replaceAll(".", "").toString()) : 0 : 0,
            swap: p.swap,
            codigo_Franquia_Swap: p.swap ? p.codigo_Franquia_Swap : null,
            codigo_Pick_Swap: p.swap ? p.codigo_Pick_Swap : null,
            protecao: p.protecao,
            inicio_Protecao: p.protecao ? p.inicio_Protecao : null,
            fim_Protecao: p.protecao ? p.fim_Protecao : null,
            codigo_Pick_Novo: p.protecao ? p.codigo_Pick_Novo : null,
        })) : [];


        dados = {
            ...dados,
            codigo_Liga: codigoLiga !== null ? Number(codigoLiga) : 0,
            codigo_Temporada: codigoTemporada,
            codUsuCriacao: user.codUsuario,
            data_Hora: new Date(),
            observacao: JSON.stringify(dadosObservacao),
            proposta_Troca: lstPropostasAux
        }

        if (idEdicao === 0) {
            PropostaService.Create(dados)
                .then((result) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Proposta cadastrada com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    setRedirecionar(`/liga/propostas/completa`);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível cadastrar a proposta! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        else if (idEdicao > 0) {
            dados = {
                ...dados,
                codigo: idEdicao,
            }
            PropostaService.CreateContraProposta(dados)
                .then((result) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Contra Proposta cadastrada com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    setRedirecionar(`/liga/propostas/completa`);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        //logout();
                        //setRedirecionar("0");
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível criar a liga! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }

    };

    const handleSimulation = async () => {
        //let dados: IDadosSavePropostas = null;        

        setLstDadosPropostaEnvia([]);
        setRemoveLoading(false);
        setIsLoading(true);
        setShowModalMensagem(false);
        setObservacao(JSON.stringify(dadosObservacao));
        let lst: IDadosPropostaTroca[] = [];
        lstDadosPropostaCabecalho.forEach(f => (
            f.dados_Propostas.map(m => {
                if (lst.length === 0) {
                    lst.push(m);
                }
                if ((m.tipo_Ativo === 1 || m.tipo_Ativo === 2) && lst.find(x => x.codigo_Jogador === m.codigo_Jogador) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 3 && lst.find(x => x.codigo_Multa === m.codigo_Multa) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 4 && lst.find(x => x.codigo_Pick_Franquia === m.codigo_Pick_Franquia) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 5 && lst.find(x => x.codigo_Pick_Franquia === m.codigo_Pick_Franquia) === undefined) {
                    lst.push(m);
                }
                if (m.tipo_Ativo === 6 && lst.find(x => x.codigo_Pick_Franquia === m.codigo_Pick_Franquia) === undefined) {
                    lst.push(m);
                }
            })));

        setLstDadosPropostaEnvia(lst);

        var propostaEnvolvida = lst.find(f => f.codigo_Franquia_Envia === codigoFranquia || f.codigo_Franquia_Recebe === codigoFranquia);
        if (propostaEnvolvida === undefined) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Não é possível registrar a Proposta! A sua franquia não está envolvida!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        const lstPropostasAux: any = lst.length > 0 ? lst.map(p => ({
            codigo_Franquia_Envia: p.codigo_Franquia_Envia,
            codigo_Franquia_Recebe: p.codigo_Franquia_Recebe,
            codigo_Jogador: p.codigo_Jogador !== undefined && p.codigo_Jogador > 0 ? p.codigo_Jogador : null,
            codigo_Jogador_Dispensa: p.codigo_Jogador_Dispensa !== undefined && p.codigo_Jogador_Dispensa > 0 ? p.codigo_Jogador_Dispensa : null,
            codigo_Pick_Franquia: p.codigo_Pick_Franquia !== undefined && p.codigo_Pick_Franquia > 0 ? p.codigo_Pick_Franquia : null,
            codigo_Multa: p.codigo_Multa !== undefined && p.codigo_Multa > 0 ? p.codigo_Multa : null,
            tipo_Ativo: p.tipo_Ativo,
            valor_Multa_Quebrada: separarMultaTemporada === 3 ? p.valor_Multa !== undefined ? parseFloat(p.valor_Multa?.replace("R$", "").replaceAll(".", "").toString()) : 0 : 0,
            swap: p.swap,
            codigo_Franquia_Swap: p.swap ? p.codigo_Franquia_Swap : null,
            codigo_Pick_Swap: p.swap ? p.codigo_Pick_Swap : null,
            protecao: p.protecao,
            inicio_Protecao: p.protecao ? p.inicio_Protecao : null,
            fim_Protecao: p.protecao ? p.fim_Protecao : null,
            codigo_Pick_Novo: p.protecao ? p.codigo_Pick_Novo : null,
        })) : [];

        let dados: IDadosSavePropostas = {
            codigo_Liga: codigoLiga !== null ? Number(codigoLiga) : 0,
            codigo_Temporada: codigoTemporada,
            codUsuCriacao: user.codUsuario,
            data_Hora: new Date(),
            observacao: JSON.stringify(dadosObservacao),
            proposta_Troca: lstPropostasAux
        }

        PropostaService.Simulate(dados)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: result.dado.toString(),
                    display: "none",
                    titulo: "Atenção"
                });


            })
            .catch((errors) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível cadastrar a proposta! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(-1);
        }
    };

    const handleChangeTabsRodadas = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabRodada(newValue);
    };

    const handleAdicionar = () => {
       
        if (codigoTipoAtivo === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o tipo de ativo!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (codigoAtivo === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o ativo!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (franquiaEnvia === franquiaRecebe) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "A franquia que recebe não pode ser igual a que envia!",
                display: "none",
                titulo: "Atenção"
            });
            return;

        }

        if (lstDadosPropostaCabecalho.find(f => f.dados_Propostas.find(d => d.codigo_Jogador === codigoAtivo
            || d.codigo_Jogador_Dispensa === codigoAtivo
            || d.codigo_Multa === codigoAtivo
            || d.codigo_Pick_Franquia === codigoAtivo))?.codigo_Franquia_Envia !== undefined) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Esse ativo já existe nos itens da proposta!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (codigoTipoAtivo === 3 && separarMultaTemporada === 3) {
            let valorAtual = lstAtivos.find(f => f.codigo === codigoAtivo)?.valor
            if (valorAtual !== undefined) {
                if (parseFloat(valorMultaEditada.replace("R$", "").replaceAll(".", "")) > parseFloat(valorAtual.replace("R$", "").replaceAll(".", ""))) {
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "O valor informado é maior que o valor atual da multa!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setValorMultaEditada("");
                    return;
                }
            }
        }

        if (codigoTipoAtivo === 6) {
            if (codigoAtivo > 0 && codigoAtivoSwap === 0) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Favor informar o ativo da Swap!",
                    display: "none",
                    titulo: "Atenção"
                });
                setValorMultaEditada("");
                return;
            }
        }

        if (codigoTipoAtivo === 5 || codigoTipoAtivo === 6) {
            if ((inicioProtecao <= 0 || fimProtecao <= 0) && codigoAtivoSwapProtegida > 0) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Favor informar a proteção da Pick",
                    display: "none",
                    titulo: "Atenção"
                });
                setValorMultaEditada("");
                return;

            }

            if (inicioProtecao > fimProtecao) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Início da proteção maior que o fim da proteção! Favor corrigir.",
                    display: "none",
                    titulo: "Atenção"
                });
                setValorMultaEditada("");
                return;

            }
            if (inicioProtecao > 0 && fimProtecao > 0 && codigoAtivoSwapProtegida === 0) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Favor informar a Pick de proteção!",
                    display: "none",
                    titulo: "Atenção"
                });
                setValorMultaEditada("");
                return;

            }
        }
        setDadosObservacao([...dadosObservacao, codigoTipoAtivo === 1 ? "Adicionado item do tipo jogadores"
            : codigoTipoAtivo === 2 ? "Adicionado item do tipo jogadores dispensa"
                : codigoTipoAtivo === 3 ? "Adicionado item do tipo multa"
                    : codigoTipoAtivo === 5 ? "Adicionado item do tipo Pick Protegida"
                        : codigoTipoAtivo === 6 ? "Adicionado item do tipo Swap"
                            : "Adicionado item do tipo pick"
        ]);

        let lstitens = lstDadosPropostaCabecalho.find(f => (f.codigo_Franquia_Envia === franquiaEnvia))?.dados_Propostas;
        let indexItem = lstitens !== null && lstitens !== undefined ? lstitens?.length + 1 : 1;
        //let lstitensRec = lstPropostaRecebe.find(f => (f.codigo_Franquia_Recebe === franquiaRecebe))?.dados_Propostas;        
        //let indexItemRec = lstitensRec !== null && lstitensRec !== undefined ? lstitensRec?.length + 1 : 1;
        // if (lstDadosPropostaCabecalho.length === 0) {
        //     indexItem = 1;
        // }
        // else {
        //     let lstitens = lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia)?.dados_Propostas;
        //     indexItem = lstitens !== null && lstitens !== undefined ? lstitens?.length + 1 : 1;
        // }

        
        let fraquiaEnvolvidaEnvia = lstFranquiaDrop.find(f => f.codigo === franquiaEnvia);
        let fraquiaEnvolvidaRecebe = lstFranquiaDrop.find(f => f.codigo === franquiaRecebe);    
        var proposta: any = {
            codigo: indexItem,
            codigo_Franquia_Envia: franquiaEnvia,
            nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
            logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
            codigo_Franquia_Recebe: franquiaRecebe,
            nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
            logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
            codigo_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? codigoAtivo : 0,
            nome_Jogador: codigoTipoAtivo === 1 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : codigoTipoAtivo === 3 && separarMultaTemporada === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros :"",
            valor_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "",
            tempo_Contrato_Jogador: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : "0,00",
            codigo_Multa: codigoTipoAtivo === 3 ? codigoAtivo : 0,
            valor_Multa: codigoTipoAtivo === 3 ? separarMultaTemporada === 3 ? formatNumber.format(Number(valorMultaEditada)) : lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "0",
            tipo_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.tipo_Multa : "0",
            codigo_Temporada_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
            descricao_Temporada_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : "",
            nome_Jogador_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
            quantidade_Anos_Multa: codigoTipoAtivo === 3 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.quantidade_Anos_Multa : 1,
            codigo_Jogador_Dispensa: codigoTipoAtivo === 2 ? codigoAtivo : 0,
            nome_Jogador_Dispensa: codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
            codigo_Pick_Franquia: codigoTipoAtivo === 5 || codigoTipoAtivo === 4 || codigoTipoAtivo === 6 ? codigoAtivo : 0,
            rodada_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.rodada : codigoTipoAtivo === 5 || codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.outros : "",
            ano_Pick: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.descricao : codigoTipoAtivo === 5 || codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.descricao : "",
            primeira_Pick_Swap: codigoTipoAtivo === 6 || codigoTipoAtivo === 5 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.label : "",
            segunda_Pick_Swap: codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.label : "",
            terceira_Pick_Swap: codigoTipoAtivo === 6 || codigoTipoAtivo === 5 ? lstAtivos.find(f => f.codigo === codigoAtivoSwapProtegida)?.label : "",
            descricao_Posicao_Final: codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.valor : "",
            codigo_Proposta_Troca_Nova: 0,
            swap: codigoTipoAtivo === 6,
            codigo_Franquia_Swap: codigoTipoAtivo === 6 ? franquiaRecebe : null,
            codigo_Pick_Swap: codigoTipoAtivo === 6 ? lstAtivoSwap.find(f => f.codigo === codigoAtivoSwap)?.codigo : "",
            protecao: codigoTipoAtivo === 5 || (inicioProtecao > 0 && fimProtecao > 0),
            inicio_Protecao: inicioProtecao,
            fim_Protecao: fimProtecao,
            codigo_Pick_Novo: codigoAtivoSwapProtegida,
            tipo_Ativo: codigoTipoAtivo,
            nome_Franquia_Origem_Pick:  codigoTipoAtivo === 4 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros : "",
            imagem: codigoTipoAtivo === 1 || codigoTipoAtivo === 2 ? lstAtivos.find(f => f.codigo === codigoAtivo)?.outros
                : codigoTipoAtivo === 3 ? imagemMulta
                    : codigoTipoAtivo === 4 ? imagemPicks
                        : codigoTipoAtivo === 5 ? imagemPicksProtegida
                            : codigoTipoAtivo === 6 ? imagemSwap
                                : ""
        };

        if (lstDadosPropostaCabecalho.length === 0) {
            var cabecalhoProp: any = [{
                codigo: 1,
                logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
                codigo_Franquia_Envia: franquiaEnvia,
                nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
                nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
                logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                codigo_Franquia_Recebe: franquiaRecebe,
                nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                dados_Propostas: [proposta]
            }];

            setLstDadosPropostaCabecalho(cabecalhoProp);

        }
        else {
            if (lstDadosPropostaCabecalho.length > 0 && lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia) !== undefined) {
                lstDadosPropostaCabecalho.find(f => f.codigo_Franquia_Envia === franquiaEnvia)?.dados_Propostas.push(proposta);

            }
            else {

                setLstDadosPropostaCabecalho([...lstDadosPropostaCabecalho, {
                    codigo: lstDadosPropostaCabecalho.length + 1,
                    logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
                    codigo_Franquia_Envia: franquiaEnvia,
                    nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
                    nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
                    logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                    codigo_Franquia_Recebe: franquiaRecebe,
                    nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                    nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                    situacao: 1,
                    dados_Propostas: [proposta]
                }]);

            }
        }

        if (lstPropostaRecebe.length === 0) {
            var cabecalhoProp: any = [{
                codigo: 1,
                logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
                codigo_Franquia_Envia: franquiaEnvia,
                nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
                nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
                logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                codigo_Franquia_Recebe: franquiaRecebe,
                nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                dados_Propostas: [proposta]
            }];

            setLstPropostaRecebe(cabecalhoProp);
        }
        else {

            if (lstPropostaRecebe.length > 0 && lstPropostaRecebe.find(f => f.codigo_Franquia_Recebe === franquiaRecebe) !== undefined) {
                lstPropostaRecebe.find(f => f.codigo_Franquia_Recebe === franquiaRecebe)?.dados_Propostas.push(proposta);
            }
            else {

                setLstPropostaRecebe([...lstPropostaRecebe, {
                    codigo: lstDadosPropostaCabecalho.length + 1,
                    logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
                    codigo_Franquia_Envia: franquiaEnvia,
                    nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
                    nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
                    logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                    codigo_Franquia_Recebe: franquiaRecebe,
                    nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                    nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                    situacao: 1,
                    dados_Propostas: [proposta]
                }]);

            }
            if (lstPropostaRecebe.length > 0 && lstPropostaRecebe.find(f => f.codigo_Franquia_Recebe === franquiaRecebe) === undefined) {
                setLstPropostaRecebe([...lstPropostaRecebe, {
                    codigo: lstDadosPropostaCabecalho.length + 1,
                    logo_Franquia_Envia: fraquiaEnvolvidaEnvia?.outros,
                    codigo_Franquia_Envia: franquiaEnvia,
                    nome_Franquia_Envia: fraquiaEnvolvidaEnvia?.label,
                    nome_General_Manager_Envia: fraquiaEnvolvidaEnvia?.descricao,
                    logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
                    codigo_Franquia_Recebe: franquiaRecebe,
                    nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
                    nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
                    situacao: 1,
                    dados_Propostas: [proposta]
                }]);
            }
        }
        setLstAtivos([]);
        setCodigoTipoAtivo(0);
        setValorMultaEditada("");
        setShowAtivosSwap(false);
        setCodigoAtivo(0);
        setCodigoAtivoSwap(0);
        setCodigoAtivoSwapProtegida(0);
        setInicioProtecao(0);
        setFimProtecao(0);

    }

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);

    }

    const handleSelectedTipoAtivo = async (e: { target: { name: string; value: any; }; }) => {
        let val = e.target.value;
        setShowAtivosSwap(false);
        setMultaQuebrada(false);
        setLstAtivos([]);
        setLstAtivoSwap([]);
        setCodigoAtivo(0);
        setCodigoAtivoSwapProtegida(0);
        setInicioProtecao(0);
        setFimProtecao(0);
        //setCodigoTipoAtivo(val);        
        if (franquiaEnvia === 0) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a franquia envia!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        if (franquiaRecebe === 0) {
            setShowModalMensagem(true);

            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a franquia recebe!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }

        await PropostaService.getPropostasAtivos(Number(franquiaEnvia))
            .then((result) => {
                setIsLoading(false);
                let dadosAtivos = result.dado;
                if (dadosAtivos !== undefined) {
                    if (val === 1) {
                        let lstJogadores = dadosAtivos.jogadores.map((f, i) => ({ codigo: f.codigo, label: f.nome, outros: f.foto, valor: f.valor_Contrato, descricao: f.tempo_Contrato.toString() }));
                        setLstAtivos(lstJogadores !== undefined ? lstJogadores : []);
                    }
                    else if (val === 2) {
                        let lstJogadoresDispensa = dadosAtivos.jogadores_Dispensa.map((f, i) => ({ codigo: f.codigo, label: f.nome, outros: f.foto }));
                        setLstAtivos(lstJogadoresDispensa !== undefined ? lstJogadoresDispensa : []);
                    }
                    else if (val === 3) {
                        setMultaQuebrada(dadosAtivos.separar_Multa_Temporada === 3);                       
                        if (dadosAtivos.separar_Multa_Temporada === 1) {
                            let lstMultas = dadosAtivos.multas_Completo.map((f, i) => ({ codigo: f.codigo, label: f.nome_Jogador + " - R$ " + moedaRealLocaleValue(f.valor_Multa), outros: f.codigo_Temporada.toString(), valor: "R$ " + moedaRealLocaleValue(f.valor_Multa), descricao: f.descricao_Temporada, tipo_Multa: dadosAtivos.separar_Multa_Temporada, quantidade_Anos_Multa: f.quantidade_Anos_Multa }));                          
                            setLstAtivos(lstMultas !== undefined ? lstMultas : []);
                        }
                        else {
                            let lstMultas = dadosAtivos.multas_Temporada.map((f, i) => ({ codigo: f.codigo, label:f.nome_Jogador + " (" + f.descricao_Temporada + ") - R$ " + moedaRealLocaleValue(f.valor_Multa), outros: f.nome_Jogador, valor: "R$ " + moedaRealLocaleValue(f.valor_Multa), descricao: f.descricao_Temporada, tipo_Multa: dadosAtivos.separar_Multa_Temporada }));                          
                            setLstAtivos(lstMultas !== undefined ? lstMultas : []);
                        }
                    }
                    else if (val === 4) {
                        let lstPicks = dadosAtivos.picks.map((f, i) => ({
                            codigo: f.codigo,
                            label: f.rodada === 1 ? "First - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem : "Second - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem,
                            outros: f.franquia_Origem,
                            descricao: f.rodada === 1 ? "First - " + f.ano.toString() : "Second - " + f.ano.toString(),
                            valor: f.posicao_Final !== undefined ? f.descricao_Posicao_Final : "",
                            rodada: f.rodada

                        }));

                        setLstAtivos(lstPicks !== undefined ? lstPicks : []);
                    }
                    else if (val === 5) {
                        let lstPicks = dadosAtivos.picks.map((f, i) => ({
                            codigo: f.codigo,
                            label: f.rodada === 1 ? "First - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem : "Second - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem,
                            outros: f.franquia_Origem,
                            descricao: f.rodada === 1 ? "First - " + f.ano.toString() : "Second - " + f.ano.toString(),
                            valor: f.posicao_Final !== undefined ? f.descricao_Posicao_Final : "",
                            codigoTemporada: f.codigo_Temporada,
                            rodada: f.rodada
                        }));
                        setLstAtivos(lstPicks !== undefined ? lstPicks : []);
                    }
                    else if (val === 6) {
                        let lstPicks = dadosAtivos.picks.map((f, i) => ({
                            codigo: f.codigo,
                            label: f.rodada === 1 ? "First - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem : "Second - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem,
                            outros: f.franquia_Origem,
                            descricao: f.rodada === 1 ? "First - " + f.ano.toString() : "Second - " + f.ano.toString(),
                            valor: f.posicao_Final !== undefined ? f.descricao_Posicao_Final : "",
                            codigoTemporada: f.codigo_Temporada,
                            rodada: f.rodada
                        }));

                        setLstAtivos(lstPicks !== undefined ? lstPicks : []);
                    }
                }
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });


    };

    const handleExcluirItemProposta = (codigoProposta: any, codigoItemProposta: any, codigoFranquiaEnvia: number, codigoFranquiaRecebe: number, tipo_Ativo: number) => {

        // if (window.confirm("Realmente deseja apagar?")) {

        if (lstDadosPropostaCabecalho !== undefined) {

            let lstAux = lstDadosPropostaCabecalho.map(m => ({
                ...m,
                dados_Propostas: m.codigo === codigoProposta ? m.dados_Propostas.filter(f => f.codigo !== Number(codigoItemProposta)) : m.dados_Propostas
            }));

            // if (lstAux.find(f => f.codigo_Franquia_Envia === codigoFranquia)?.dados_Propostas.length === 0) {
            //     let lstAux2 = lstAux.filter(f => f.codigo_Franquia_Envia !== codigoFranquia);
            //     setLstDadosPropostaCabecalho(lstAux2);
            //     return;
            // }

            setLstDadosPropostaCabecalho(lstAux);

        }

        if (lstPropostaRecebe !== undefined) {
            let lstAux = lstPropostaRecebe.map(m => ({
                ...m,
                dados_Propostas: m.codigo === codigoProposta ? m.dados_Propostas.filter(f => f.codigo !== Number(codigoItemProposta)) : m.dados_Propostas
            }));

            // if (lstAux.find(f => f.codigo_Franquia_Envia === codigoFranquia)?.dados_Propostas.length === 0) {
            //     let lstAux2 = lstAux.filter(f => f.codigo_Franquia_Envia !== codigoFranquia);
            //     setLstDadosPropostaCabecalho(lstAux2);
            //     return;
            // }

            setLstPropostaRecebe(lstAux);

        }
        //}
    }

    const handleSelecionarFranquia = (e: { target: { name: string; value: any; }; }) => {
        setLstAtivos([]);
        setCodigoTipoAtivo(0);
        setCodigoAtivo(0);
        setCodigoAtivoSwap(0);
        setCodigoAtivoSwapProtegida(0);
        setValorMultaEditada("");

    }

    const handleInverterFranquias = (e: any) => {
        setFranquiaEnvia(franquiaRecebe);
        setFranquiaRecebe(franquiaEnvia);
        setLstAtivos([]);
        setCodigoTipoAtivo(0);
        setValorMultaEditada("");

    }

    const handleVerificarValorMulta = (e: { target: { name: string; value: any; }; }) => {
        let nvValor = e.target.value;
        let valorAtual = lstAtivos.find(f => f.codigo === codigoAtivo)?.valor;

        if (valorAtual !== undefined) {
            if (parseFloat(nvValor) > parseFloat(valorAtual.replace("R$", "").replaceAll(".", ""))) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "O valor informado é maior que o valor atual da multa!",
                    display: "none",
                    titulo: "Atenção"
                });
                setValorMultaEditada("");
                return;
            }
            setValorMultaEditada(nvValor);
        }
    }

    const carregarValorDaMulta = (codigo: number) => {
        if (codigo === 3) {
            let valor = lstAtivos.find(f => f.codigo === codigo)?.valor;
            if (valor !== undefined) {
                setValorMultaEditada(parseFloat(valor.replace("R$", "").replaceAll(".", "")).toString());
            }
        }
    }

    const carregarDadosAtivos = async (codigoAtivo: number) => {
        setCodigoAtivo(codigoAtivo);
        carregarValorDaMulta(codigoAtivo);

        if (codigoTipoAtivo === 5 || codigoTipoAtivo === 6) {
            setShowAtivosSwap(true);
            let dadosAtivoTemporada = lstAtivos.find(f => f.codigo === codigoAtivo);
            if (dadosAtivoTemporada !== undefined) {
                let temp = dadosAtivoTemporada.codigoTemporada != undefined ? dadosAtivoTemporada.codigoTemporada : 0;
                let rod = dadosAtivoTemporada.rodada !== undefined ? dadosAtivoTemporada.rodada : 0;
                await PropostaService.getPropostasAtivoSwap(Number(franquiaRecebe), temp, rod)
                    .then((result) => {
                        setIsLoading(false);
                        let dadosAtivos = result.dado;
                      
                        let lstPicks = dadosAtivos.map((f, i) => ({
                            codigo: f.codigo,
                            label: f.rodada === 1 ? "First - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem : "Second - " + (f.posicao_Final !== null ? f.descricao_Posicao_Final : "") + " " + f.ano.toString() + " - " + f.franquia_Origem,
                            outros: f.franquia_Origem,
                            descricao: f.rodada === 1 ? "First - " + f.ano.toString() : "Second - " + f.ano.toString(),
                            valor: f.posicao_Final !== undefined ? f.descricao_Posicao_Final : "",
                            codigoTemporada: f.codigo_Temporada
                        }));
                        setLstAtivoSwap(lstPicks !== undefined ? lstPicks : []);

                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });
            }
        }
    }

    return (
        <LayoutBaseDePagina
            titulo={`Liga - ${nomeLiga}`}
            showLogoImg={logoImage}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={true}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate("/liga/propostas/completa")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container padding={2} spacing={2}>
                        <Grid container size={{ xs: 12, sm: 12 }} >
                            <Grid size={{ xs: 12, sm: 9, md: 9 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Criar Proposta</Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent={"center"} alignSelf={"center"}>
                                <Button
                                    color="success"
                                    variant="contained"
                                    disableElevation
                                    onClick={() => handleSimulation()}
                                    startIcon={<Icon>construction</Icon>}
                                    disabled={isLoading}
                                >
                                    <Typography variant="button" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
                                        Simular
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={1}>
                            <Grid size={{ xs: 11, sm: 5, md: 5 }}  >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Envia</InputLabel>
                                    <Select
                                        native={false}
                                        value={franquiaEnvia}
                                        label="Envia"
                                        defaultValue={0}
                                        onChange={(e) => { setFranquiaEnvia(Number(e.target.value)); handleSelecionarFranquia(e) }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstFranquiaDrop.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 11, sm: 5, md: 5 }}  >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Recebe</InputLabel>
                                    <Select
                                        native={false}
                                        value={franquiaRecebe}
                                        label="Recebe"
                                        defaultValue={0}
                                        onChange={(e) => { setFranquiaRecebe(Number(e.target.value)); handleSelecionarFranquia(e) }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstFranquiaDrop.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 1, sm: 2, md: 2 }} display="flex" alignSelf="center">
                                <IconButton size="small" onClick={(e) => handleInverterFranquias(e)}>
                                    <Icon style={{ fontSize: UtilidadeService.isMobile() ? 16 : "auto" }}>flip_camera_android</Icon>
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start" spacing={1}>
                            <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Tipos Ativos</InputLabel>
                                    <Select
                                        value={codigoTipoAtivo}
                                        label="Tipos Ativos"
                                        defaultValue={0}
                                        onChange={(e) => { setCodigoTipoAtivo(Number(e.target.value)); handleSelectedTipoAtivo(e); }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            separarMultaTemporada === 4 ?
                                                lstTiposAtivosProposta.filter(f => f.codigo !== 3).map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                : lstTiposAtivosProposta.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Ativos</InputLabel>
                                    <Select
                                        value={codigoAtivo}
                                        label="Ativos"
                                        defaultValue={0}
                                        onChange={(e) => { carregarDadosAtivos(Number(e.target.value)); }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstAtivos.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl>
                            </Grid>
                            {showAtivosSwap && (
                                <>
                                    <Grid size={{ xs: 6, sm: 2, md: 2 }} display={codigoTipoAtivo === 6 ? "flex" : "none"}>
                                        <FormControl fullWidth disabled={isLoading}>
                                            <InputLabel id="demo-simple-select-label">Ativos Swap</InputLabel>
                                            <Select
                                                value={codigoAtivoSwap}
                                                label="Ativos Swap"
                                                defaultValue={0}
                                                onChange={(e) => { setCodigoAtivoSwap(Number(e.target.value)); }}
                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                            >
                                                <MenuItem value={0}>Selecione</MenuItem>
                                                {
                                                    lstAtivoSwap.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                }

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                        <TextField
                                            defaultValue={0}
                                            type="text"
                                            label="Início Proteção"
                                            value={inicioProtecao}
                                            onChange={(e) => { setInicioProtecao(Number(e.target.value)); }}
                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}

                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 2, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                        <TextField
                                            defaultValue={0}
                                            type="text"
                                            label="Fim Proteção"
                                            value={fimProtecao}
                                            onChange={(e) => { setFimProtecao(Number(e.target.value)); }}
                                            style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}

                                        />
                                    </Grid>
                                    <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                        <FormControl fullWidth disabled={isLoading}>
                                            <InputLabel id="demo-simple-select-label">Swap Protegida</InputLabel>
                                            <Select
                                                value={codigoAtivoSwapProtegida}
                                                label="Swap Protegida"
                                                defaultValue={0}
                                                onChange={(e) => { setCodigoAtivoSwapProtegida(Number(e.target.value)); }}
                                                style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                            >
                                                <MenuItem value={0}>Selecione</MenuItem>
                                                {
                                                    lstAtivos.filter(f => f.codigo > codigoAtivo).map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                }

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </>
                            )}
                            {multaQuebrada &&
                                <Grid size={{ xs: 12, sm: 2, md: 2 }} display="flex" alignItems="center" justifyContent="flex-end" justifyItems="center" textAlign="end">
                                    <TextField
                                        defaultValue={0}
                                        type="text"
                                        label="Valor Multa"
                                        value={valorMultaEditada}
                                        onChange={(e) => { handleVerificarValorMulta(e); }}
                                        slotProps={{
                                            input: {
                                                inputComponent: NumericFormatCustom as any,
                                            }
                                        }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                    />
                                </Grid>
                            }
                            <Grid size={{ xs: 12, sm: showAtivosSwap ? 12 : 5, md: showAtivosSwap ? 12 : 5 }} display="flex" alignItems="center" justifyContent="end" paddingRight={2} >
                                <Button
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    disabled={isLoading}
                                    onClick={handleAdicionar}
                                    startIcon={<Icon>add</Icon>}
                                    style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto" }}                                >
                                    Adicionar
                                </Button>
                            </Grid>
                        </Grid>
                        {!removeLoading && <Loading />}
                        <Grid container direction="column" size={{ xs: 12, sm: 12, md: 12 }}  >
                            <Grid alignItems="center" justifyContent="center" width="100%">
                                <Grid alignItems="center" justifyContent="center" width="99%">
                                    <Paper>
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <Tabs value={valueTab}
                                                onChange={handleChangeTabsRodadas}
                                                variant="scrollable"
                                                scrollButtons
                                                sx={{
                                                    [`& .${tabsClasses.scrollButtons}`]: {
                                                        '&.Mui-disabled': { opacity: 0.3 },
                                                    },
                                                }}
                                            >
                                                <Tab label="Envia"  {...a11yProps(0)} />
                                                <Tab label="Recebe" {...a11yProps(1)} />
                                            </Tabs>
                                        </Box>
                                        <TabPanel value={valueTab} index={0}>
                                            {!isLoading && lstDadosPropostaCabecalho.length > 0 ?
                                                <Grid container spacing={2}
                                                    style={{
                                                        margin: UtilidadeService.isMobile() ? 0 : "auto", paddingLeft: UtilidadeService.isMobile() ? 0 : 2,
                                                        width: UtilidadeService.isMobile() ? "100%" : "auto"
                                                    }}
                                                >
                                                    {lstDadosPropostaCabecalho.map((cab, i) => (
                                                        <Grid key={`Grid1${i}`} container size={{ xs: 12, sm: 12 }} margin={1} style={{ backgroundColor: theme.palette.mode === 'dark' ? "#28292b" : "#d3d3ce", paddingLeft: 0 }}>
                                                            <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1} margin={1} display="flex" direction="column" maxHeight={135}>
                                                                <Grid size={{ xs: 12, sm: 4 }} paddingLeft={1} paddingRight={1}>
                                                                    <img src={cab.logo_Franquia_Envia}
                                                                        alt={cab.nome_Franquia_Envia?.split(" ")[0]}
                                                                        width={UtilidadeService.isMobile() ? 65 : 130} height={UtilidadeService.isMobile() ? 65 : 130}
                                                                    />
                                                                </Grid>
                                                                <Grid container size={{ xs: 12, sm: 8 }} paddingLeft={1} paddingRight={1} width="92%">
                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                        <Typography variant='h5' style={{ fontSize: UtilidadeService.isMobile() ? 16 : 24 }} fontWeight="bold">
                                                                            {cab.nome_Franquia_Envia}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                        <Typography variant='body1' style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                                            {cab.nome_General_Manager_Envia}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1}>
                                                                <hr />
                                                            </Grid>
                                                            {cab.dados_Propostas.filter(f => f.codigo_Franquia_Envia === cab.codigo_Franquia_Envia).length > 0 ? cab.dados_Propostas.filter(f => f.codigo_Franquia_Envia === cab.codigo_Franquia_Envia).map((prop, i) => (
                                                                <Grid container size={{ xs: 12, sm: 6 }} display="flex" direction="row">
                                                                    <Grid key={`Grid${i}`} size={{ xs: 12, sm: 12, md: 12 }} margin={1} >
                                                                        <Card key={`Card${i}`} >
                                                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                                                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                                                    <CardContent sx={{ paddingBottom: 1 }} >
                                                                                        <Grid container size={{ xs: 12, sm: 12, md: 12 }}  >
                                                                                            <Grid size={{ xs: 3, sm: 4, md: 4 }} padding={0}>
                                                                                                <img src={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                                                                    prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                                                                    alt={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                                                                        prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                                                                    width={UtilidadeService.isMobile() ? 50 : 130} height={UtilidadeService.isMobile() ? 50 : 130}
                                                                                                />
                                                                                            </Grid>
                                                                                            <Grid size={{ xs: 9, sm: 8, md: 8 }} display="flex" justifyContent="center" alignItems="center" alignSelf="center" padding={1} >
                                                                                                {(prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2) && (
                                                                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "auto"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                        <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                {prop.tipo_Ativo === 1 ? prop.nome_Jogador : prop.nome_Jogador_Dispensa}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                R${prop.valor_Jogador !== undefined ? moedaRealLocaleValue(prop.valor_Jogador) : "0"}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                {prop.tempo_Contrato_Jogador !== undefined ? prop.tempo_Contrato_Jogador + " ano(s)" : "0 ano"}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                {prop.nome_Franquia_Recebe} RECEBE
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {prop.tipo_Ativo === 3 && prop.tipo_Multa !== 1 && (
                                                                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                        <Grid size={{ xs: 12, sm: 12 }} paddingBottom={2}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Multa: {cab.nome_Franquia_Recebe}
                                                                                                            </Typography>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Jogador:  {prop.nome_Jogador}
                                                                                                            </Typography>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Valor: {prop.valor_Multa}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                Ano: {prop.descricao_Temporada_Multa}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                {prop.nome_Franquia_Recebe} RECEBE
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {prop.tipo_Ativo === 3 && prop.tipo_Multa === 1 && (
                                                                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                        <Grid size={{ xs: 12, sm: 12 }} paddingBottom={2}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Multa: {cab.nome_Franquia_Recebe}
                                                                                                            </Typography>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Jogador:  {prop.nome_Jogador_Multa?.split("-")[0]}
                                                                                                            </Typography>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Valor:  {`${prop.nome_Jogador_Multa?.split("-")[1]} / ${prop.quantidade_Anos_Multa}`}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 12, sm: 12 }} >
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                {prop.nome_Franquia_Recebe} RECEBE
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {prop.tipo_Ativo === 4 && (
                                                                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "auto"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                        <Grid size={{ xs: 10, sm: 10 }} paddingBottom={1}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Pick: {prop.descricao_Posicao_Final !== undefined && prop.descricao_Posicao_Final !== "" && prop.descricao_Posicao_Final !== null ? prop.descricao_Posicao_Final
                                                                                                                    : prop.rodada_Pick !== undefined && prop.rodada_Pick === 1 ? `First - ${prop.nome_Franquia_Origem_Pick}` : `Second - ${prop.nome_Franquia_Origem_Pick}`}
                                                                                                            </Typography>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                {"Ano: " + prop.ano_Pick}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                Recebe: {prop.nome_Franquia_Recebe}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                {prop.nome_Franquia_Recebe} RECEBE
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {prop.tipo_Ativo === 5 && (
                                                                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "auto"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                        <Grid size={{ xs: 10, sm: 10 }} paddingBottom={1}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Melhor Pick: {prop.nome_Franquia_Recebe}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                Picks Envolvidas
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                * {prop.primeira_Pick_Swap}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                * {prop.terceira_Pick_Swap}
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                {prop.nome_Franquia_Envia} ENVIA
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {prop.tipo_Ativo === 6 && (
                                                                                                    <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "auto"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                        <Grid size={{ xs: 10, sm: 10 }} paddingBottom={1}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                Melhor Pick: {prop.nome_Franquia_Recebe}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                Picks Envolvidas
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                * {prop.primeira_Pick_Swap !== undefined ? prop.primeira_Pick_Swap : prop.rodada_Pick === 1 ? "First " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick : "Second " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick}
                                                                                                            </Typography>
                                                                                                            <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                * {prop.segunda_Pick_Swap !== undefined ? prop.segunda_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap}
                                                                                                            </Typography>
                                                                                                            {prop.inicio_Protecao !== undefined && prop.inicio_Protecao > 0 && prop.fim_Protecao !== undefined && prop.fim_Protecao > 0 && (
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    {`* (${prop.inicio_Protecao} - ${prop.fim_Protecao})  ${prop.terceira_Pick_Swap !== undefined ? prop.terceira_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao}`}
                                                                                                                </Typography>
                                                                                                            )}
                                                                                                        </Grid>
                                                                                                        <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                {prop.nome_Franquia_Envia} ENVIA
                                                                                                            </Typography>
                                                                                                        </Grid>
                                                                                                    </Box>
                                                                                                )}
                                                                                            </Grid>
                                                                                            <Grid container size={{ xs: 12, sm: 12 }} display={UtilidadeService.isMobile() ? "flex" : "grid"} justifyContent={UtilidadeService.isMobile() ? "start" : "end"} flexDirection={UtilidadeService.isMobile() ? "row" : "column"}>
                                                                                                <Grid size={{ xs: 6, sm: 12 }} display="flex" justifyContent="start" justifySelf="center" alignItems="center" style={{ marginTop: UtilidadeService.isMobile() ? -25 : -215, paddingLeft: "5px" }}>
                                                                                                    <img src={prop.logo_Franquia_Recebe === null ? semImagem : prop.logo_Franquia_Recebe} alt={prop.nome_Franquia_Recebe} width={UtilidadeService.isMobile() ? 40 : 75} height={UtilidadeService.isMobile() ? 40 : 75} />
                                                                                                </Grid>
                                                                                                <Grid size={{ xs: 6, sm: 12 }} display="flex" justifyContent="end" justifySelf="center" textAlign="end" alignSelf={"center"} style={{ marginTop: UtilidadeService.isMobile() ? -205 : -50, paddingLeft: "5px" }}>
                                                                                                    <Tooltip key={i} title="Excluir" >
                                                                                                        <CardActionArea onClick={() => handleExcluirItemProposta(cab.codigo, prop.codigo, prop.codigo_Franquia_Envia, prop.codigo_Franquia_Recebe, prop.tipo_Ativo)}>
                                                                                                            <Icon sx={{ padding: 1 }} >delete</Icon>
                                                                                                        </CardActionArea>
                                                                                                    </Tooltip>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </CardContent>
                                                                                </Grid>
                                                                            </Grid>
                                                                        </Card>
                                                                    </Grid>
                                                                </Grid>
                                                            ))
                                                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" margin={2} >
                                                                    <Typography variant="body1" sx={{ color: "#CD1E03" }}>Esta franquia não possui itens a enviar, nessa proposta. </Typography>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6">Nenhuma proposta encontrada </Typography>
                                                    <hr />
                                                </Grid>
                                            }
                                        </TabPanel>
                                        <TabPanel value={valueTab} index={1}>
                                            {!isLoading && lstPropostaRecebe.length > 0 ?
                                                <Grid container spacing={2} style={{ margin: UtilidadeService.isMobile() ? 0 : "auto", paddingLeft: UtilidadeService.isMobile() ? 0 : 2, width: UtilidadeService.isMobile() ? "100%" : "auto" }}>
                                                    {lstPropostaRecebe.map((cab, i) => (
                                                        <Grid key={`Grid2${i}`} container size={{ xs: 12, sm: 12 }} margin={1} style={{ backgroundColor: theme.palette.mode === 'dark' ? "#28292b" : "#d3d3ce", paddingLeft: 0 }} >
                                                            <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1} margin={1} display="flex" direction="column" maxHeight={UtilidadeService.isMobile() ? 60 : 135}>
                                                                <Grid size={{ xs: 12, sm: 3 }} paddingLeft={1} paddingRight={1}>
                                                                    <img src={cab.logo_Franquia_Recebe}
                                                                        alt={cab.nome_Franquia_Recebe?.split(" ")[0]}
                                                                        width={UtilidadeService.isMobile() ? 65 : 130} height={UtilidadeService.isMobile() ? 65 : 130}
                                                                    />
                                                                </Grid>
                                                                <Grid container size={{ xs: 12, sm: 8 }} paddingLeft={1} paddingRight={1} width={UtilidadeService.isMobile() ? "70%" : "92%"}>
                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                        <Typography variant='h5' style={{ fontSize: UtilidadeService.isMobile() ? 16 : 24 }} fontWeight="bold">
                                                                            {cab.nome_Franquia_Recebe}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                        <Typography variant='body1' style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                                            {cab.nome_General_Manager_Recebe}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} paddingLeft={1} paddingRight={1}>
                                                                <hr />
                                                            </Grid>
                                                            {cab.dados_Propostas.filter(f => f.codigo_Franquia_Recebe === cab.codigo_Franquia_Recebe).length > 0
                                                                ? cab.dados_Propostas.filter(f => f.codigo_Franquia_Recebe === cab.codigo_Franquia_Recebe).map((prop, i) => (
                                                                    <Grid key={`Grid1${i}`} container size={{ xs: 12, sm: 6 }} display="flex" direction="row">
                                                                        <Grid key={`Grid${i}`} size={{ xs: 12, sm: 12, md: 12 }} margin={1} >
                                                                            <Card key={`Card${i}`} >
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                                    <Grid size={{ xs: 12, sm: 12 }}>
                                                                                        <CardContent sx={{ paddingBottom: 1 }} >
                                                                                            <Grid container size={{ xs: 12, sm: 12, md: 12 }} >
                                                                                                <Grid size={{ xs: 3, sm: 4, md: 4 }} padding={0}>
                                                                                                    <img src={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                                                                        prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                                                                        alt={prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2 ? prop.imagem || prop.foto_Jogador :
                                                                                                            prop.tipo_Ativo === 3 ? imagemMulta : prop.tipo_Ativo === 5 ? imagemPicksProtegida : prop.tipo_Ativo === 6 ? imagemSwap : imagemPicks}
                                                                                                        width={UtilidadeService.isMobile() ? 50 : 130} height={UtilidadeService.isMobile() ? 50 : 130}
                                                                                                    />
                                                                                                </Grid>
                                                                                                <Grid size={{ xs: 9, sm: 8, md: 8 }} display="flex" justifyContent="center" alignItems="center" alignSelf="center" padding={1} >
                                                                                                    {(prop.tipo_Ativo === 1 || prop.tipo_Ativo === 2) && (
                                                                                                        <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                            <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    {prop.tipo_Ativo === 1 ? prop.nome_Jogador : prop.nome_Jogador_Dispensa}
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 12, sm: 12 }} paddingBottom={1}>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    R${prop.valor_Jogador !== undefined ? moedaRealLocaleValue(prop.valor_Jogador) : "0"}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    {prop.tempo_Contrato_Jogador !== undefined ? prop.tempo_Contrato_Jogador + " ano(s)" : "0 ano"}
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 12, sm: 12 }}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                    {prop.nome_Franquia_Envia} ENVIA
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                    {prop.tipo_Ativo === 3 && prop.tipo_Multa !== 1 && (
                                                                                                        <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                            <Grid size={{ xs: 12, sm: 12 }} paddingBottom={2}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Multa: {cab.nome_Franquia_Recebe}
                                                                                                                </Typography>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Valor: {prop.valor_Multa}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    Ano: {prop.descricao_Temporada_Multa}
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                    {prop.nome_Franquia_Envia} ENVIA
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                    {prop.tipo_Ativo === 3 && prop.tipo_Multa === 1 && (
                                                                                                        <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                            <Grid size={{ xs: 12, sm: 12 }} paddingBottom={2}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Multa: {cab.nome_Franquia_Recebe}
                                                                                                                </Typography>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Jogador:  {prop.nome_Jogador_Multa?.split("-")[0]}
                                                                                                                </Typography>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Valor:  {`${prop.nome_Jogador_Multa?.split("-")[1]} / ${prop.quantidade_Anos_Multa}`}
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                    {prop.nome_Franquia_Envia} ENVIA
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                    {prop.tipo_Ativo === 4 && (
                                                                                                        <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "150px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                            <Grid size={{ xs: 10, sm: 10 }} paddingBottom={1}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Pick: {prop.descricao_Posicao_Final !== undefined && prop.descricao_Posicao_Final !== "" && prop.descricao_Posicao_Final !== null ? prop.descricao_Posicao_Final
                                                                                                                        : prop.rodada_Pick !== undefined && prop.rodada_Pick === 1 ? `First - ${prop.nome_Franquia_Origem_Pick}` : `Second - ${prop.nome_Franquia_Origem_Pick}`}
                                                                                                                </Typography>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    {"Ano: " + prop.ano_Pick}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    Recebe: {prop.nome_Franquia_Recebe}
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                    {prop.nome_Franquia_Envia} ENVIA
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                    {prop.tipo_Ativo === 5 && (
                                                                                                        <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "auto"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                            <Grid size={{ xs: 10, sm: 10 }} paddingBottom={1}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Melhor Pick: {prop.nome_Franquia_Recebe}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    Picks Envolvidas
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    * {prop.primeira_Pick_Swap}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    * {prop.terceira_Pick_Swap}
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                    {prop.nome_Franquia_Envia} ENVIA
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                    {prop.tipo_Ativo === 6 && (
                                                                                                        <Box width="100%" height={UtilidadeService.isMobile() ? "100px" : "175px"} display="flex" flexDirection="column" justifyItems="start">
                                                                                                            <Grid size={{ xs: 10, sm: 10 }} paddingBottom={1}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>
                                                                                                                    Melhor Pick: {prop.nome_Franquia_Recebe}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    Picks Envolvidas II
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    * {prop.primeira_Pick_Swap !== undefined ? prop.primeira_Pick_Swap : prop.rodada_Pick === 1 ? "First " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick : "Second " + prop.ano_Pick + " - " + prop.nome_Franquia_Origem_Pick}
                                                                                                                </Typography>
                                                                                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                    * {prop.segunda_Pick_Swap !== undefined ? prop.segunda_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Swap}
                                                                                                                </Typography>
                                                                                                                {prop.inicio_Protecao !== undefined && prop.inicio_Protecao > 0 && prop.fim_Protecao !== undefined && prop.fim_Protecao > 0 && (
                                                                                                                    <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 16 }}>
                                                                                                                        {`* (${prop.inicio_Protecao} - ${prop.fim_Protecao})  ${prop.terceira_Pick_Swap !== undefined ? prop.terceira_Pick_Swap : prop.rodada_Pick_Swap === 1 ? "First " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao : "Second " + prop.ano_Pick_Swap + " - " + prop.nome_Franquia_Origem_Pick_Protecao}`}
                                                                                                                    </Typography>
                                                                                                                )}
                                                                                                            </Grid>
                                                                                                            <Grid size={{ xs: 10, sm: 10 }}>
                                                                                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }} sx={{ color: "#fbc02d" }} >
                                                                                                                    {prop.nome_Franquia_Envia} ENVIA
                                                                                                                </Typography>
                                                                                                            </Grid>
                                                                                                        </Box>
                                                                                                    )}
                                                                                                </Grid>
                                                                                                <Grid container size={{ xs: 12, sm: 12 }} display={UtilidadeService.isMobile() ? "flex" : "grid"} justifyContent={UtilidadeService.isMobile() ? "start" : "end"} flexDirection={UtilidadeService.isMobile() ? "row" : "column"}>
                                                                                                    <Grid size={{ xs: 6, sm: 12 }} display="flex" justifyContent="start" justifySelf="center" alignItems="center" style={{ marginTop: UtilidadeService.isMobile() ? -25 : -215, paddingLeft: "5px" }}>
                                                                                                        <img src={prop.logo_Franquia_Envia === null ? semImagem : prop.logo_Franquia_Envia} alt={prop.nome_Franquia_Envia} width={UtilidadeService.isMobile() ? 40 : 75} height={UtilidadeService.isMobile() ? 40 : 75} />
                                                                                                    </Grid>
                                                                                                    <Grid size={{ xs: 6, sm: 12 }} display="flex" justifyContent="end" justifySelf="center" textAlign="end" alignSelf={"center"} style={{ marginTop: UtilidadeService.isMobile() ? -205 : -50, paddingLeft: "5px" }}>
                                                                                                        <Tooltip key={i} title="Excluir" >
                                                                                                            <CardActionArea onClick={() => handleExcluirItemProposta(cab.codigo, prop.codigo, prop.codigo_Franquia_Envia, prop.codigo_Franquia_Recebe, prop.tipo_Ativo)}>
                                                                                                                <Icon sx={{ padding: 1 }} >delete</Icon>
                                                                                                            </CardActionArea>
                                                                                                        </Tooltip>
                                                                                                    </Grid>
                                                                                                </Grid>
                                                                                            </Grid>
                                                                                        </CardContent>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Card>
                                                                        </Grid>
                                                                    </Grid>
                                                                ))
                                                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" margin={2} >
                                                                    <Typography variant="body1" sx={{ color: "#CD1E03" }}>Esta franquia não possui itens a receber, nessa proposta. </Typography>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                : <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Nenhuma proposta encontrada </Typography>
                                                    <hr />
                                                </Grid>
                                            }
                                        </TabPanel>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    )
};

